// extracted by mini-css-extract-plugin
module.exports = {"worningStyle":"EmployeeAllocationEditPopup_worningStyle__3zQFG","iconStyle":"EmployeeAllocationEditPopup_iconStyle__2ThZ8","loading":"EmployeeAllocationEditPopup_loading__2njiq"};